<template>
  <div class="zl_login">
    <el-button @click="noticeBtn" class="notice_btn">通知公告</el-button>
    <img src="../../static/images/newLoginPage/logo.png" class="teach_home_logo"/>
    <img src="../../static/images/newLoginPage/homepagePic.png" class="teach_home_pic"/>
    <!-- <img src="../../static/images/newLoginPage/newhomeTitle.png" class="teach_home_title"/> -->
    <!-- <img src="../../static/images/newLoginPage/homeTitle.png" class="teach_home_title"/> -->
    <p class="teach_home_title">实训教学综合服务平台</p>
    <p class="teach_home_msg">
      基于中联集团产业集群服务全国百万企业实践，创新智慧财经职业教育与培训体系，共建高水平专业化产教融合实训基地技术创新平台
    </p>

    <!-- 登录窗口                   loginStatus 0 登录  1修改密码  2完善信息  3找回密码 -->
    <div class="login_window" v-if="loginStatus === 0">
      <div class="password_title">
        <h1>Welcome欢迎登录</h1>
      </div>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="username">
          <el-input v-model.trim="loginForm.username" placeholder="请输入用户名" type="text" autocomplete="off" prefix-icon="el-icon-user" @keyup.enter.native="submitForm('loginForm')"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model.trim="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password maxLength="18" @keyup.enter.native="submitForm('loginForm')"></el-input>
        </el-form-item>
        <el-form-item prop="validCode" style="margin-bottom:8px;">
          <el-input v-model.trim="loginForm.validCode" placeholder="请输入验证码" type="text" autocomplete="off" prefix-icon="el-icon-key" maxLength="10" @keyup.enter.native="submitForm('loginForm')"></el-input>
          <div class="verificationCode_btn" @click="getCode">
            <img :src="imgurl" alt="加载失败"/>
          </div>
          <el-input v-model="loginForm.uuid" v-show="false"></el-input>
        </el-form-item>
        <div class="forget">
          <a @click="forgetPassword('loginForm')">忘记密码</a>
        </div>
        <el-button type="primary" @click="submitForm('loginForm')" class="login_btn">立即登录</el-button>

      </el-form>
    </div>
    <!-- 修改密码                   loginStatus 0 登录  1修改密码  2完善信息  3找回密码 -->
    <div class="login_window" v-else-if="loginStatus === 1">
      <div class="password_title">
        <h1>修改密码</h1>
        <p v-if="passwordLongTime">您的密码长时间未更新，为了您的账号安全请修改密码！</p>
        <p v-else>您的密码过于简单，为了您的账号安全请修改密码！</p>
      </div>
      <el-form :model="passwordEditForm" :rules="passwordEditRules" ref="passwordEditForm">
        <el-form-item prop="newpassword">
          <el-input v-model.trim="passwordEditForm.newpassword" placeholder="请输入新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password @keyup.enter.native="submitPasswordEdit('passwordEditForm')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newrepeatpassword" style="margin-bottom:8px;margin-top: 30px">
          <el-input v-model.trim="passwordEditForm.newrepeatpassword" placeholder="重复新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password @keyup.enter.native="submitPasswordEdit('passwordEditForm')" autocomplete="off"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: space-between;align-items: flex-end;">
          <el-button type="primary" @click="submitPasswordEdit('passwordEditForm')" class="login_btn" style="width:200px;">提 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 交</el-button>
          <el-button v-if="passwordLongTime" type="text" @click="getLoginName()">跳过</el-button>
          <el-button v-else type="text" @click="cancelEdit('passwordEditForm')">返回</el-button>
        </div>
      </el-form>
    </div>
    <!-- 完善个人信息                loginStatus 0 登录  1修改密码  2完善信息  3找回密码 -->
    <div class="login_window" v-else-if="loginStatus === 2">
      <div class="password_title">
        <h1>完善个人信息</h1>
      </div>
      <el-form :model="bindingPhoneForm" :rules="bindingPhoneRules" ref="bindingPhoneForm">
        <el-form-item prop="moblie">
          <el-input v-model.trim="bindingPhoneForm.moblie" placeholder="请输入要绑定的手机号" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-user" maxLength="11"></el-input>
        </el-form-item>
        <el-form-item prop="phonecode">
          <el-input v-model.trim="bindingPhoneForm.phonecode" placeholder="请输入验证码" type="text" autocomplete="off" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-key" maxLength="10"></el-input>
          <el-button v-if="showCode" class="code-btn" type="primary" @click="sendMessage('bindingPhoneForm')">获取验证码</el-button>
          <el-button v-else class="code-btn" type="primary" disabled> {{count}}秒 </el-button>
        </el-form-item>
        <el-form-item prop="newpassword" style="margin-bottom: 30px;">
          <el-input v-model.trim="bindingPhoneForm.newpassword" placeholder="请输入新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newrepeatpassword" style="margin-bottom:8px;">
          <el-input v-model.trim="bindingPhoneForm.newrepeatpassword" placeholder="重复新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password autocomplete="off"></el-input>
        </el-form-item>
        <div style="display: flex;justify-content: space-between;align-items: flex-end;">
          <el-button type="primary" @click="submitBindingForm('bindingPhoneForm')" class="login_btn" style="width:200px;">确 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;定</el-button>
          <el-button type="text" @click="cancelEdit('bindingPhoneForm')">取消</el-button>
        </div>
      </el-form>
    </div>
    <!-- 忘记密码，找回密码           loginStatus 0 登录  1修改密码  2完善信息  3找回密码 -->
    <div class="login_window" v-else-if="loginStatus === 3">
      <div class="password_title">
        <h1>找回密码</h1>
      </div>
      <el-form :model="retrieveForm" :rules="retrieveRules" ref="retrieveForm">
        <el-form-item prop="moblie">
          <el-input v-model.trim="retrieveForm.moblie" placeholder="注册手机号" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-user" maxLength="20" @keyup.enter.native="submitRetrieveForm('retrieveForm')"></el-input>
        </el-form-item>
        <el-form-item prop="phonecode">
          <el-input v-model.trim="retrieveForm.phonecode" placeholder="请输入验证码" type="text" autocomplete="off" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-key" maxLength="10" @keyup.enter.native="submitRetrieveForm('retrieveForm')"></el-input>
          <el-button v-if="showCode" class="code-btn" type="primary" @click="getPhoneCode('retrieveForm',retrieveForm)">
            获取验证码
          </el-button>
          <el-button v-else class="code-btn" type="primary" disabled>
            {{count}}秒
          </el-button>
        </el-form-item>
        <el-form-item prop="newpassword">
          <el-input v-model.trim="retrieveForm.newpassword" placeholder="请输入新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password @keyup.enter.native="submitRetrieveForm('retrieveForm')" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="newrepeatpassword" style="margin-bottom:8px;margin-top: 28px">
          <el-input v-model.trim="retrieveForm.newrepeatpassword" placeholder="重复新密码" type="password" :readonly="readonlyInput" @focus="cancelReadOnly()" prefix-icon="el-icon-lock" show-password @keyup.enter.native="submitRetrieveForm('retrieveForm')" autocomplete="off"></el-input>
        </el-form-item>
        <div class="forget">
          <a @click="cancelEdit('retrieveForm')">返回登录</a>
        </div>
        <el-button type="primary" @click="submitRetrieveForm('retrieveForm')" class="login_btn">提   交</el-button>

      </el-form>
    </div>

    <div class="teach_home_footer">
      <p>技术支持：中联集团教育科技有限公司</p>
      <div class="jump">
        友情链接：
        <el-link type="danger" :underline="false" @click="goUrl('https://china-united.cn/')">中联集团</el-link>
        <el-link type="danger" :underline="false" @click="goUrl('https://www.lhrj.cn/')">领航人杰</el-link>
      </div>
    </div>
    <renew-dialog :showModalconfirm="outerVisible" @onclickCancel="onclickCancel" @innerclickConfirm="innerclickConfirm"></renew-dialog>
  </div>
</template>
<script>
  import * as api from "../api/userApi";
  import AES from "../utils/AES.js";
  import qs from 'qs';
  import renewDialog from "../components/dialog/renewDialog/index.vue"
  export default {
    name:'login',
    components: {renewDialog},
    data() {
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.retrieveForm.newpassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      // var bindingvalidatePass = (rule, value, callback) => {
      //   if (!value){
      //     return callback(new Error('请输入密码'));
      //   }else{
      //     if(value == '123456'){
      //       return callback(new Error('密码不能为123456'));
      //     }else{
      //       if (this.bindingPhoneForm.newrepeatpassword !== '') {
      //         this.$refs.bindingPhoneForm.validateField('newrepeatpassword');
      //       }
      //       callback();
      //     }
      //   }
      // };
      var bindingvalidatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.bindingPhoneForm.newpassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else {
          callback();
        }
      };
      var editvalidatePass = (rule, value, callback) => {
				var reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,16}$/
        // var reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,16}$/;
        if (!value) {
          return callback(new Error('请输入密码'));
        } else if (!reg.test(value)) {
          callback(new Error('密码包含大小写字母、数字、特殊符号其中的三种或三种以上、长度在 8 到 16 个字符'));
        } else {
          callback();
        }
      }
      var editvalidatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passwordEditForm.newpassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        sessionStorageConfiguration:{},
        imgurl: '',
        loginForm: {  // process.env.NODE_ENV === 'production' 为本地部署环境。
          /* 某院校特殊处理登录次数问题 */
          // client_id: process.env.NODE_ENV === 'production'?'gxzx-local':'1163687109021044738',
          // client_secret: process.env.NODE_ENV === 'production'?'gxzxlc1d23491111ecab640c42a1e1243':'23915e847ed736b72d98857686075b66',
          client_id: process.env.NODE_ENV === 'production'?'1385769698363113473':'1163687109021044738',
          client_secret: process.env.NODE_ENV === 'production'?'c439d32c72542272164b1647f3fc9811':'23915e847ed736b72d98857686075b66',
          grant_type: 'password',
          username: '',
          password: '',
          uuid:'',
          validCode: '',
          passwordType: 'power',
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          validCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ]
        },
        retrieveForm:{
          moblie:'',
          phonecode:'',
          newpassword:'',
          newrepeatpassword:'',
          passwordType: 'power',
        },
        retrieveRules:{
          moblie: [
            { validator: checkPhone, trigger: 'blur' }
          ],
          newpassword: [{ required: true,  validator: editvalidatePass, trigger: 'blur' }],
          newrepeatpassword: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          phonecode: [
            { validator: validateCode, trigger: 'blur' }
          ]
        },
        bindingPhoneForm:{
          moblie:'',
          phonecode:'',
          newpassword:'',
          newrepeatpassword:''
        },
        bindingPhoneRules:{
          moblie: [ {  required: true, validator: checkPhone, trigger: 'blur' } ],
          newpassword: [ { required: true,  validator: editvalidatePass, trigger: 'blur' }],
          newrepeatpassword: [ {  required: true, validator: bindingvalidatePass2, trigger: 'blur' } ],
          phonecode: [ {  required: true, validator: validateCode, trigger: 'blur' } ]
        },
        loginflag:true,
        appFlag:'sharingcenter',
        // teachImg:'../../../static/img/login/teach-bg.png',
        // courseImg:'../../../static/img/login/course-bg.png',
        userType:sessionStorage.getItem('userType')?sessionStorage.getItem('userType'):'',

        readonlyInput:true,
        timer:null,
        showCode:true,
        count:'',
        isbinding: localStorage.getItem('isbinding') ? localStorage.getItem('isbinding') : '',
        loginBtn: true,
        routerArr:[],
        passwordLongTime: false,// 密码是否很长时间没更新，（90天）
        passwordEditForm: {
          newpassword:'',
          newrepeatpassword:'',
        },
        passwordEditRules:{
          newpassword: [
            { required: true,  validator: editvalidatePass, trigger: 'blur' },
          ],
          newrepeatpassword: [ { validator: editvalidatePass2, trigger: 'blur' } ],
        },
        allRolesList: [],
        outerVisible: false,
        temporaryName: '',
        //
        loginStatus: 0, // 0 登录  1修改密码  2完善信息  3找回密码
      }
    },
    // beforeCreate() {
    //   if(localStorage.getItem('appFlag')==='sharingcenter'||localStorage.getItem('appFlag')===''){
    //     localStorage.clear();
    //     sessionStorage.clear();
    //   }
    // },
    created() {
      /**
       * 检测已经登录账号的浏览器
       * 不能再登录第二个账号
       */
			if (localStorage.sessionStorageConfiguration) {
				let a = JSON.parse(localStorage.sessionStorageConfiguration)
				for (const key in a) {
					if (Object.hasOwnProperty.call(a, key)) {
						sessionStorage.setItem(key, a[key])
						this.$router.push({
							path: "/Home"
						})
					}
				}
		  	return
			}
      localStorage.setItem('appFlag', 'sharingcenter');
      this.getCode();
      this.getDeptLogo();
    },
    mounted() {
      window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    },
    methods: {
      noticeBtn(){
        this.$router.push('/notice')
      },
      getCode(){
        api.getCode().then((rs) => {
          if (rs) {
            this.imgurl = rs.imageCode;
            this.loginForm.uuid = rs.uuid;
            this.loginForm.validCode = ''
          }
        });
      },
      getDeptLogo(){ //获取院校logo及deptNo
        let host = window.location.host;
        let hostStr = process.env.HostStr
        if(this.isIp(host)){
          hostStr = process.env.HostStr
        }else{
          if(this.isPort(host)){
            hostStr = process.env.HostStr
          }else{
            host = host.split('.')[0]
            hostStr = host
          }
        }
        let list = ['gxzxtest','sx','qzy','hbcs','csmz']
        if(this.reg(list,hostStr)){
          hostStr = process.env.HostStr
        }
        if (hostStr){
          sessionStorage.setItem('deptNo',hostStr)
        }
      },
      reg(list,type){
        return list.includes(type)
      },
      isNull(param){
        return !param && param!==0 && typeof param!=='boolean'?true:false;
      },
      isIp(strIp){
        if(this.isNull(strIp)){
          return false
        }
        let reg = /^(\d+).(\d+).(\d+).(\d+)$/g;
        if(reg.test(strIp)){
          if(RegExp.$1<256 && RegExp.$2<256 && RegExp.$3<256 && RegExp.$4<256){
            return true
          }
        }else{
          return false
        }
      },
      isPort(strPort){
        if(this.isNull(strPort)){
          return false
        }
        if(strPort=='localhost'){
          return true
        }else if(strPort.indexOf(":")>-1){
          return this.isIp(strPort.split(':')[0]) || (strPort.split(':')[0]=='localhost'?true:false)
        }else{
          return false
        }
      },
      onclickCancel(){
        this.outerVisible = false
      },
      innerclickConfirm(val){
        if(val=='ceshigxzx'){
          this.outerVisible = false
          this.submitForm(this.temporaryName)
        }else{
          this.$messageError('无权限')
        }
      },
      // aa(formName){
      //   this.outerVisible = true
      //   this.temporaryName = formName
      // },
      submitForm(formName) { //登录
        let that = this
        if(that.loginflag){
          that.loginflag = false
          that.$refs[formName].validate((valid) => {
            if (valid) {
              let obj = {
                client_id: that.loginForm.client_id,
                client_secret: that.loginForm.client_secret,
                grant_type: that.loginForm.grant_type,
                username: that.loginForm.username,
                password: AES.encrypt(that.loginForm.password),
                uuid:that.loginForm.uuid,
                validCode: that.loginForm.validCode,
                passwordType: that.loginForm.passwordType,
              }
              api.goLongin(qs.stringify(obj)).then(rs=>{
                if(rs.code == 0){
                  localStorage.setItem('Authorization', rs.data.access_token)
                  // sessionStorage.setItem('loginInfo',qs.stringify(rs.data));
                  sessionStorage.setItem('tokenType', rs.data.token_type);
                  that.getDeptIds()
                  that.getLoginName()
                }else{
                  that.$messageError(rs.msg)
                  if(rs.msg!='验证码错误'){
                    that.getCode();
                  }
                  that.loginflag = true
                }
                that.getCode();
              }).catch((error)=>{
                console.log(error)
              })
            } else {
              that.loginflag = true
              return false;
            }
          });
        }
      },
      getDeptIds(){ //获取开放单项评分院校集合
        api.getDeptIds().then(rs=>{
          if(rs.code==0){
            let arr = []
            rs.data.forEach(v=>{
              arr.push(v.deptId)
            })
            sessionStorage.setItem('deptIds',JSON.stringify(arr))
          }else{
            sessionStorage.setItem('deptIds',JSON.stringify([]))
          }
        })
      },
      //获取用户基本信息
      async getLoginName(){
          // api.getUser({ appFlag: 'sharingcenter' }).then(res=>{
          api.getUser().then(res=>{
            if(res.status === 1){

              this.allRolesList = res.roles
              this.userType = res.type
              this.setStorage(res);  // 存储信息到本地

                /*
                 *  只有学生需要完善信息。
                 *  Number(res.type) === 2
                 *  author: ljl && 王进产品  2023.2.14
                 */
              if (Number(res.type) === 2 && !res.mobile){

                localStorage.setItem('isbinding','0')
                this.loginStatus = 2  //   loginStatus: 0, // 0 登录  1修改密码  2完善信息  3找回密码
                this.loginflag = false
                return;

              }
              // else{
              //   localStorage.setItem('isbinding','1')
              //   this.isbinding = '1'
              //   this.loginflag = true
              // }


                if(this.loginForm.password === '123456'){
                  this.loginStatus = 1   //   loginStatus: 0, // 0 登录  1修改密码  2完善信息  3找回密码
                }else{

                  if (this.passwordLongTime){
                    this.passwordLongTime = false;
                  }else{
                    /* 密码超过90天没有修改，提醒修改密码 */
                    let nowTime = new Date().getTime();
                    let createTime = new Date(res.updatePasswordTime).getTime() || new Date(res.createTime).getTime();
                    let day = (nowTime-createTime)/(24*60*60*1000)

                    if (day > 90){
                      this.passwordLongTime = true;
                      this.loginStatus = 1   //   loginStatus: 0, // 0 登录  1修改密码  2完善信息  3找回密码
                      return
                    }
                  }

                  if(this.userType==2||this.userType==3){
                    this.$router.push('/Home')
                  }else{
                    this.getMenuAndBtn()
                  }
                }

            }else{
              this.$messageError(res.msg)
            }
          }).catch(err=>{
            console.log(err)
          })
      },
      // 存储信息到本地
      setStorage(res){
        sessionStorage.setItem('userId',res.userId);
        sessionStorage.setItem('deptId',res.deptId);
        sessionStorage.setItem('deptName',res.deptName);
        sessionStorage.setItem('loginName',res.nickname);
        sessionStorage.setItem('userName',res.username);
        sessionStorage.setItem('sex',res.sex?res.sex:1);
        sessionStorage.setItem('userType',res.type);
        sessionStorage.setItem('mobile',res.mobile || 18888888888);
        sessionStorage.setItem('auditStatus',res.auditStatus);
        sessionStorage.setItem('provinceId',res.provinceId);
				sessionStorage.setItem('deptType',res.deptType);
        if(res.sysUserPermissionList && res.sysUserPermissionList.length){
          let sysUserPermissionList = res.sysUserPermissionList;
          // productId   1综合实训，2单项实训
          // studentOnoff 教师权限
          // teacherOnoff 学生权限
          localStorage.setItem('sysUserPermissionList',JSON.stringify(sysUserPermissionList));
        }
      },
      // getStructId(){ //获取组织id
      //   api.queryUserStruct().then(rs => {
      //     if(rs.code==0){
      //       sessionStorage.setItem('structId',rs.data.structId);
      //     }else{
      //       this.$messageError(rs.msg)
      //     }
      //   })
      // },
      //获取用户角色权限
      getMenuAndBtn(){
        // api.getUser().then(rs=>{
        // if(rs.status==1){

        let data = this.allRolesList;
        let sharingcenterConfigure = [];
        let platformadminConfigure = [];
        if(data.length>0){
          data.forEach( item =>{
            if(item.appFlag==="sharingcenter"){
              sharingcenterConfigure.push({
                menuId:item.menuIdStr,
                roleId:item.roleIdStr
              })
            }else if(item.appFlag==="platformadmin"){
              platformadminConfigure.push({
                menuId:item.menuIdStr,
                roleId:item.roleIdStr
              })
            }
          })
        }

         sessionStorage.setItem('sharingcenterConfigure', '');
        if(sharingcenterConfigure.length){
          sessionStorage.setItem('sharingcenterConfigure', JSON.stringify(sharingcenterConfigure));
        }

         sessionStorage.setItem('isPlatformadmin', '')
        if (platformadminConfigure.length && this.userType==='0'){
          sessionStorage.setItem('isPlatformadmin', '1')
          this.findMenu(platformadminConfigure,'platformadmin')
        }else{
          this.$router.push('/Home')
        }

        // }
        // })
      },
      findMenu(platformadmin,appFlag){
        let obj = {
          list: platformadmin,
          appFlag: appFlag
        }
        api.findMenu(obj).then(rs=>{
          if(rs.code==0){
            let routerObj = {
              appFlag: appFlag,
              arr: rs.data.menus
            }
            this.routerArr.push(routerObj)

          //   加密 this.$AES.AES_Encrypt
          //   解密  this.$AES.AES_Decrypt
            sessionStorage.setItem('routerPermissions', this.$AES.AES_Encrypt(JSON.stringify(this.routerArr)) );
                if(rs.data.permissions.length>0){
             sessionStorage.setItem('btnPermissions', this.$AES.AES_Encrypt(JSON.stringify(rs.data.permissions)) );
            }

            this.$router.push('/Home')
          }else{
            this.$messageError(rs.msg)
          }
        })
      },
      forgetPassword(formName){ // 忘记密码
        this.loginStatus = 3;
        this.$refs[formName].resetFields();
      },
      cancelReadOnly() {
        this.readonlyInput= false;
      },
      submitBindingForm(formName){ //绑定手机号&修改密码
        this.loginflag = true
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {
              mobile:this.bindingPhoneForm.moblie,
              userType:this.userType,
              newPassword:this.bindingPhoneForm.newpassword,
              repetitionPassword: this.bindingPhoneForm.newrepeatpassword,
              code:this.bindingPhoneForm.phonecode
              // code:888888
            }
            api.updateUserPasswordInfo(obj).then(rs=>{
              if(rs.code==0){
                this.$messageSuccess('保存成功,请重新登录！')
                this.cancelEdit(formName)
              }else if(rs.code == 2){
                this.$confirm('该手机号已经存在, 是否与原账号解除绑定，重新绑定新账号?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  let obj = {
                    mobile:this.bindingPhoneForm.moblie,
                    userType:this.userType,
                    newPassword:this.bindingPhoneForm.newpassword,
                    repetitionPassword: this.bindingPhoneForm.newrepeatpassword,
                  }
                  api.userPhoneUnbind(obj).then(res => {
                    if (res.code == 0) {
                      this.$messageSuccess('保存成功,请重新登录！')
                      this.cancelEdit(formName)
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                })
              } else{
                this.$messageError(rs.msg)
              }
            }).catch(err=>{
              console.log(err)
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      sendMessage(formName){//完善信息获取验证码
        this.$refs[formName].validateField("moblie",(phoneError)=>{
          if(!phoneError){
            const TIME_COUNT = 60;
            // 原有验证码 api
            api.sendMessage(qs.stringify({phone:this.bindingPhoneForm.moblie})).then(rs=>{
              if (String(rs.code) === '0'){
                this.$messageSuccess("验证码已发送,请注意查收");
              }else {
                this.$messageError(rs.msg || '未知错误')
              }
              this.count = TIME_COUNT;
              this.showCode = false;
              this.timer = setInterval(()=>{
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.showCode = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              },1000);
            }).catch(err=>{
              console.log(err)
            })
          }
        });
      },
      submitRetrieveForm(formName){ //找回密码提交
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let param = {
              mobile:this.retrieveForm.moblie,
              code:this.retrieveForm.phonecode,
              password:this.retrieveForm.newpassword
            }
            api.foundByTel(param).then(res=>{
              if(res.code == 0){
                this.$messageSuccess(res.msg);
                this.cancelEdit(formName);
              }else{
                this.$messageError('验证码错误，请重新输入');
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getPhoneCode(reform,form){//找回密码获取验证码
        this.$refs[reform].validateField('moblie', (errMsg) => {
          if (errMsg) {
            console.log('手机号不能为空');
          }else{
            let param = {
              phone:form.moblie
            };
            const TIME_COUNT = 60;
            api.getPhoneCode(qs.stringify(param)).then(res=>{
              if(res.code == 0){
                this.$messageSuccess("验证码已发送,请注意查收");
                this.count = TIME_COUNT;
                this.showCode = false;
                this.timer = setInterval(()=>{
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.showCode = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                },1000);
              }else{
                this.$messageError(res.msg);
              }
            }).catch((error)=>{
              console.log(error)
            })
          }
        })
      },
      submitPasswordEdit(formName){ //强制密码修改提交
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.loginForm.password === this.passwordEditForm.newpassword){
             return  this.$messageWarning('新密码不能与之前密码相同')
            }
            let obj = {
              password: AES.encrypt(this.loginForm.password),
              newPassword: AES.encrypt(this.passwordEditForm.newpassword),
              passwordType: 'power',
            };
            api.updatePassword(obj).then(res => {
              if (res.code == 0) {
                this.cancelEdit(formName);
                this.$messageSuccess('密码修改成功')
              } else {
                this.$messageError(res.msg);
              }
            }).catch(error => {
              console.log(error);
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      cancelEdit(formName){
        this.passwordLongTime = false;
        this.loginStatus = 0
        this.loginflag = true;
        if(this.$refs[formName]){
          this.$refs[formName].clearValidate();
        }
        this.LogOut();
        this.getCode();
      },
      //退出
      LogOut(){
        if(localStorage.getItem('Authorization')){
          api.logout(localStorage.getItem('Authorization')).then(rs=>{ console.log(rs) })
        }
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('appFlag', 'sharingcenter')
      },
      goUrl(url) {
        window.open(url, "_blank");
      }
    },
  }
</script>
<style lang="scss">
  .zl_login{
    width: 100%;
    height: 100%;
    background: linear-gradient(316deg,rgba(104,231,177,1) 0%,rgba(75,132,255,1) 100%);
    position: relative;

    .login_window{
      width: 330px;
      padding: 30px 0;
      background:rgba(255,255,255,1);
      border-radius:8px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15%;
      z-index: 9;
      .password_title{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 35px;
        h1{
          font-size:20px;
          font-weight:400;
          color: rgba(51,51,51,1);
          letter-spacing:8px;
        }
        p{
          width: 240px;
          margin: 10px auto 0;
          font-size: 13px;
          color: #66b1ff;
          line-height: 20px;
        }
      }
      .el-form{
        width: 240px;
        margin: 0 auto;
        .forget{
          text-align: right;
          a{
            color:rgba(153,153,153,1);
            font-size:14px;
            font-weight:400;
            cursor: pointer;
            &:hover{
              color: #5397f7;
            }
          }
        }
        .el-form-item{
          .el-form-item__content{
            .code-btn {
              position: absolute;
              top: 4px;
              right: 4px;
              width:77px !important;
              height:32px !important;
              line-height: 32px !important;
              padding: 0;
              text-align: center;
              font-size: 12px;
            }
          }
        }
        .el-form-item__error{
          padding-top: 2px;
        }
        .login_btn{
          width:240px;
          height:40px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          font-size:16px;
          color:rgba(255,255,255,1);
          padding: 0;
          margin-top: 24px;
          &:hover{
            opacity: 0.8;
          }
        }
        .verificationCode_btn{
          img{
            position: absolute;
            top: 3px;
            right: 1px;
          }
        }
      }
    }

    .notice_btn{
      padding: 0;
      position: absolute;
      right: 56px;
      top: 48px;
      background: none;
      width: 80px;
      height: 30px;
      color: #fff;
      &:hover{
        box-shadow:0px 5px 10px rgba(0,0,0,0.3);
        background: none;
        color: #fff;
      }
    }
    .teach_home_logo{
      height: 40px;
      position: absolute;
      left: 56px;
      top: 40px;
    }
    .teach_home_title{
      height: 26px;
      position: absolute;
      left: 296px;
      top: 19%;
      color: #fff;
      font-size: 36px;
      letter-spacing: 4px;
      font-family: cursive;
    }
    .teach_home_pic{
      width: 500px;
      position: absolute;
      left: 140px;
      bottom: 72px;
    }
    .teach_home_msg{
      height: 26px;
      position: absolute;
      left: 296px;
      top: calc(20% + 40px);
      width:400px;
      font-size: 12px;
      font-weight:400;
      line-height:28px;
      color:rgba(255,255,255,1);
      letter-spacing:1px;
    }

    .teach_home_footer{
      width:100%;
      height:32px;
      background:rgba(87,87,87,0.2);
      position: fixed;
      bottom: 0;
      p{
        font-size:12px;
        font-weight:400;
        line-height: 32px;
        color:rgba(255,255,255,1);
        text-align: center;
      }

      .jump {
        position: absolute;
        top: 0;
        right: 40px;
        height: 32px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: #fff;
        font-size: 12px;

        .el-link.el-link--danger {
          font-size: 12px;
          color: #fff;

          &:hover {
            color: #fafafa;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue